const sendInFeedCardToGA4 = () => {
  const buttons = document.querySelectorAll(
    ".featured__product-default-card button"
  );
  if (!buttons.length) {
    return;
  }

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const selectContentObject = {
        event: "select_content",
        content_type: "in-feed card",
        content_title: button.dataset.contentTitle,
        content_landing_page: button.dataset.contentLandingPage,
      };

      if (window.dataLayer) {
        window.dataLayer.push(selectContentObject);
        console.log("Pushed select content object: ", selectContentObject);
      }
    });
  });
};

const sendInFeedShogunToGA4 = () => {
  const shogunLinks = document.querySelectorAll(".shogun-image-link");
  const titles = document.querySelectorAll("h1 > a");

  if (!shogunLinks.length || !titles.length) {
    return;
  }

  shogunLinks.forEach((link, index) => {
    link.addEventListener("click", () => {
      const selectContentObject = {
        event: "select_content",
        content_type: "in-feed shogun",
        content_title: titles[index].innerText,
        content_landing_page: link.href,
      };

      if (window.dataLayer) {
        window.dataLayer.push(selectContentObject);
        console.log("Pushed select content object: ", selectContentObject);
      }
    });
  });
};

const sendSelectStockistToGA4 = () => {
  if (window.location.pathname !== "/pages/store-locator") {
    return;
  }

  const _handleMutationsLiElement = (mutations) => {
    let tempId = null;
    for (const mutation of mutations) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class" &&
        mutation.target.classList.contains("stockist-selected") &&
        tempId !== mutation.target.dataset.stockistIdTempDoNotUse
      ) {
        tempId = mutation.target.dataset.stockistIdTempDoNotUse;
        const stockistObject = {
          event: "select_stockist",
          stockist_name: mutation.target.innerText.split("\n")?.[0] ?? "",
          stockist_location: mutation.target.innerText.split("\n")?.[1] ?? "",
        };
        if (window.dataLayer) {
          window.dataLayer.push(stockistObject);
          console.log("Pushed stockist object: ", stockistObject);
        }
      }
    }
  };

  const _handleMutationsStockistList = (mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (node.tagName === "UL") {
            const observer = new MutationObserver(_handleMutationsLiElement);
            Array.from(node.children).forEach((child) => {
              observer.observe(child, {
                attributes: true,
                attributeFilter: ["class"],
              });
            });
          }
        });
      }
    }
  };

  const observer = new MutationObserver(_handleMutationsStockistList);
  const interval = setInterval(() => {
    const stockistResultList = document.querySelector(".stockist-result-list");
    if (!stockistResultList) {
      return;
    }
    clearInterval(interval);
    observer.observe(stockistResultList, {
      childList: true,
    });
  }, 200);
};

const sendNewsletterSignupToGA4 = () => {
  const newsletterSignupForms = document.querySelectorAll(".newsletter-form");

  Array.from(newsletterSignupForms).forEach((form) => {
    form.addEventListener("submit", (e) => {
      // e.preventDefault();

      const signUpObject = {
        event: "sign_up",
      };

      // try {
      //   fetch(form.action, {
      //     method: "POST",
      //     body: new FormData(form),
      //   });
      // } catch (error) {
      //   console.error("Error when submitting newsletter form: ", error);
      // }

      if (window.dataLayer) {
        window.dataLayer.push(signUpObject);
        console.log("Pushed signup newsletter object: ", signUpObject);
      }
    });
  });
};

const _removeOrAddGa4MonsterCartObject = (variantId, type) => {
  let intervalCounter = 0;
  monster_getCartItems().then((data) => {
    const foundedItem = data.items.find(
      (item) => item.variant_id === variantId
    );
    const ga4ObjectFromSessionStorage = JSON.parse(
      sessionStorage.getItem(variantId)
    );

    if (
      ga4ObjectFromSessionStorage?.value === foundedItem?.line_price &&
      intervalCounter <= 10
    ) {
      setTimeout(() => _removeOrAddGa4MonsterCartObject(variantId, type), 500);
      intervalCounter++;
    } else {
      if (foundedItem && ga4ObjectFromSessionStorage) {
        type === "remove" &&
          (ga4ObjectFromSessionStorage.event = "remove_from_cart");
        type === "add" && (ga4ObjectFromSessionStorage.event = "add_to_cart");
        ga4ObjectFromSessionStorage.quantity = 1;
        ga4ObjectFromSessionStorage.value = foundedItem.price / 100.0;
        const ga4CartObject = constructGA4CartObject(foundedItem);
        if (foundedItem.quantity > 1) {
          sessionStorage.setItem(
            `${foundedItem.variant_id}`,
            JSON.stringify(ga4CartObject)
          );
        } else {
          sessionStorage.removeItem(variantId);
        }

        if (window.dataLayer && type === "remove") {
          window.dataLayer.push(ga4ObjectFromSessionStorage);
          console.log(
            "Pushed object for remove_from_cart event: ",
            ga4ObjectFromSessionStorage
          );
        } else if (window.dataLayer && type === "add") {
          window.dataLayer.push(ga4ObjectFromSessionStorage);
          console.log(
            "Pushed object for add_to_cart event: ",
            ga4ObjectFromSessionStorage
          );
        } else {
          console.error(
            "Cannot push object for add_to_cart/remove_from_cart event. Invalid event name"
          );
        }
      } else if (ga4ObjectFromSessionStorage) {
        ga4ObjectFromSessionStorage.event = "remove_from_cart";
        ga4ObjectFromSessionStorage.quantity = 1;
        ga4ObjectFromSessionStorage.value = ga4ObjectFromSessionStorage.price;
        sessionStorage.removeItem(variantId);
        if (window.dataLayer) {
          window.dataLayer.push(ga4ObjectFromSessionStorage);
          console.log(
            "Pushed object for remove_from_cart event: ",
            ga4ObjectFromSessionStorage
          );
        }
      } else {
        console.error(
          "Cannot push object for remove_from_cart event. No object found for the event"
        );
      }
    }
  });
};

let monsterCartLoaded = false;
const sendRemoveOrAddFromMonsterCartToGa4 = () => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.id === "monster-upsell-cart" && !monsterCartLoaded) {
            monsterCartLoaded = true;
            node.addEventListener("click", (event) => {
              const closestCartItem = event.target.closest(".mu-cart-item");
              const variantId = closestCartItem
                ?.querySelector("a")
                ?.href?.split("variant=")[1];
              const closestBtn = event.target.closest("button");
              const ariaLabel = closestBtn?.getAttribute("aria-label");
              if (
                (ariaLabel?.includes("decrease") ||
                  ariaLabel?.includes("remove")) &&
                variantId
              ) {
                _removeOrAddGa4MonsterCartObject(+variantId, "remove");
                sendUpsellAddToCartToGA4();
              }
              if (ariaLabel?.includes("increase") && variantId) {
                _removeOrAddGa4MonsterCartObject(+variantId, "add");
                setGa4CartObjectToSessionStorage(+variantId);
              }
            });
            observer.disconnect();
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

// use in quick-add.js, main-product.liquid, featured-product.liquid
const sendUpsellAddToCartToGA4 = () => {
  let counter = 0;
  const interval = setInterval(() => {
    const button = $('button:has(span:contains("Add To Cart"))')[0];
    if (button) {
      clearInterval(interval);
      if (button.hasClickListener) {
        return;
      }

      // internal function to push upsell_add_to_cart event
      const _pushUpsellEvent = (pushUpsellEventInteralCounter, endFunction) => {
        monster_getCartItems().then((data) => {
          for (let i = 0; i < data.items.length; i++) {
            const item = data.items[i];
            if (!sessionStorage.getItem(item.variant_id)) {
              const ga4Object = constructGA4CartObject(
                item,
                "upsell_add_to_cart"
              );
              sessionStorage.setItem(
                `${item.variant_id}`,
                JSON.stringify(ga4Object)
              );
              if (window.dataLayer) {
                window.dataLayer.push(ga4Object);
                console.log(
                  "Pushed object for upsell_add_to_cart event: ",
                  ga4Object
                );
                endFunction = true;
              }
            }
          }
          if (endFunction) {
            return;
          }

          if (pushUpsellEventInteralCounter <= 10) {
            setTimeout(
              () => _pushUpsellEvent(pushUpsellEventInteralCounter),
              500
            );
            pushUpsellEventInteralCounter++;
          } else {
            console.error(
              "Cannot push object for upsell_add_to_cart event. No object found for the event"
            );
          }
        });
      };

      button.addEventListener("click", () => {
        let endFunction = false;
        let pushUpsellEventInteralCounter = 0;
        _pushUpsellEvent(pushUpsellEventInteralCounter, endFunction);
      });
      button.hasClickListener = true;
    }
    if (counter > 10) {
      clearInterval(interval);
      console.error(
        "Cannot find Add To Cart button. Event upsell_add_to_cart will not be pushed"
      );
    }
    counter++;
  }, 500);
};

// handle traditional cart
const sendRemoveOrAddCartObjectToGA4 = () => {
  const cartContentsForm = document.querySelector("#cart");
  if (!cartContentsForm) {
    return;
  }

  cartContentsForm.addEventListener("click", (event) => {
    const cartItem = event.target.closest("tr");
    if (!cartItem) {
      return;
    }

    const quantityInput = cartItem.querySelector(".quantity__input").value;
    const variantId = cartItem.dataset.variantId;
    const ga4ObjectFromSessionStorage = JSON.parse(
      sessionStorage.getItem(`${variantId}`)
    );
    const buttonName = event.target.getAttribute("name");
    if (ga4ObjectFromSessionStorage) {
      ga4ObjectFromSessionStorage.quantity = 1;
      ga4ObjectFromSessionStorage.value = ga4ObjectFromSessionStorage.price;
    } else {
      console.error(
        "Cannot push object for add_to_cart/remove_from_cart event. No object found for the event"
      );
      return;
    }

    if (buttonName === "minus") {
      ga4ObjectFromSessionStorage.event = "remove_from_cart";
      if (quantityInput === "0") {
        sessionStorage.removeItem(variantId);
      }
      if (window.dataLayer) {
        window.dataLayer.push(ga4ObjectFromSessionStorage);
        console.log(
          "Pushed remove from cart object: ",
          ga4ObjectFromSessionStorage
        );
      }
    }

    if (buttonName === "plus") {
      ga4ObjectFromSessionStorage.event = "add_to_cart";
      if (window.dataLayer) {
        window.dataLayer.push(ga4ObjectFromSessionStorage);
        console.log("Pushed add to cart object: ", ga4ObjectFromSessionStorage);
      }
      setGa4CartObjectToSessionStorage(+variantId);
    }

    if (event.target.closest("a")) {
      ga4ObjectFromSessionStorage.event = "remove_from_cart";
      sessionStorage.removeItem(variantId);
      ga4ObjectFromSessionStorage.value =
        ga4ObjectFromSessionStorage.price * quantityInput;
      ga4ObjectFromSessionStorage.quantity = quantityInput;
      if (window.dataLayer) {
        window.dataLayer.push(ga4ObjectFromSessionStorage);
        console.log(
          "Pushed remove from cart object: ",
          ga4ObjectFromSessionStorage
        );
      }
    }
  });
};

const sendVideoToGa4 = () => {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        for (const node of mutation.addedNodes) {
          if (node.tagName === "VIDEO") {
            node.addEventListener("play", (event) => {
              const videoElement = event.target;
              const videoStartObject = constructVideoStartObject(
                videoElement.getAttribute("aria-label") ?? "",
                Math.round(videoElement.duration)
              );
              if (videoElement.currentTime < 1 && window.dataLayer) {
                console.log("Pushed video start object: ", videoStartObject);
                window.dataLayer.push(videoStartObject);
              }
            });

            node.addEventListener("pause", (event) => {
              const videoElement = event.target;
              const videoTitle = videoElement.getAttribute("aria-label") ?? "";
              const videoCurrentTime = Math.round(videoElement.currentTime);
              const videoDurarion = Math.round(videoElement.duration);
              const videoPercent = Math.round(
                (videoCurrentTime / videoDurarion) * 100
              );
              const videoProgressObject = constructVideoProgressObject(
                videoTitle,
                videoCurrentTime,
                videoPercent,
                videoDurarion
              );
              if (window.dataLayer && videoPercent < 100) {
                window.dataLayer.push(videoProgressObject);
                console.log(
                  "Pushed video progress object: ",
                  videoProgressObject
                );
              }
            });

            node.addEventListener("ended", (event) => {
              const videoElement = event.target;
              const videoTitle = videoElement.getAttribute("aria-label") ?? "";
              const videoDurarion = Math.round(videoElement.duration);
              const videoPercent = 100;
              const videoCompleteObject = constructVideoCompleteObject(
                videoTitle,
                videoPercent,
                videoDurarion
              );
              if (window.dataLayer) {
                window.dataLayer.push(videoCompleteObject);
                console.log(
                  "Pushed video complete object: ",
                  videoCompleteObject
                );
              }
            });
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
};

const sendLoginToGa4 = () => {
  const customerId = _getCustomerId();
  if (customerId && window.dataLayer) {
    window.dataLayer.push({
      event: "login",
      user_id: customerId,
    });
    console.log("Pushed login object: ", {
      event: "login",
      user_id: customerId,
    });
  }
};

window.document.addEventListener("DOMContentLoaded", function () {
  console.log("GA4 loaded");

  sendInFeedCardToGA4();
  sendInFeedShogunToGA4();
  sendSelectStockistToGA4();
  sendNewsletterSignupToGA4();
  sendRemoveOrAddFromMonsterCartToGa4();
  sendRemoveOrAddCartObjectToGA4();
  sendVideoToGa4();
  sendLoginToGa4();
});

// videos ga4 youtube

let lastTime = 0;
let currentTime = 0;

function onYouTubeIframeAPIReady() {
  console.log("Youtube API ready");
  const videos = document.querySelectorAll(".shogun-video-embed");
  Array.from(videos).forEach((video) => {
    let player = new YT.Player(video, {
      events: {
        onStateChange: onPlayerStateChange,
      },
    });
  });
}

const onPlayerStateChange = (event) => {
  if (event.data == YT.PlayerState.PLAYING) {
    const currentTime = event.target.playerInfo.currentTime;
    const videoStartObject = constructVideoStartObject(
      event.target.videoTitle,
      Math.round(event.target.playerInfo.duration)
    );
    if (currentTime < 1 && window.dataLayer) {
      window.dataLayer.push(videoStartObject);
      console.log("Pushed video start object YT: ", videoStartObject);
    }
  }

  if (event.data === YT.PlayerState.PAUSED) {
    const videoTitle = event.target.videoTitle;
    const videoCurrentTime = Math.round(event.target.playerInfo.currentTime);
    const videoDuration = Math.round(event.target.playerInfo.duration);
    const videoPercent = Math.round((videoCurrentTime / videoDuration) * 100);
    const videoProgressObject = constructVideoProgressObject(
      videoTitle,
      videoCurrentTime,
      videoPercent,
      videoDuration
    );
    if (window.dataLayer) {
      window.dataLayer.push(videoProgressObject);
      console.log("Pushed video progress object YT: ", videoProgressObject);
    }
  }

  if (event.data === YT.PlayerState.ENDED) {
    const videoTitle = event.target.videoTitle;
    const videoDuration = Math.round(event.target.playerInfo.duration);
    const videoPercent = 100;
    const videoCompleteObject = constructVideoCompleteObject(
      videoTitle,
      videoPercent,
      videoDuration
    );
    if (window.dataLayer) {
      window.dataLayer.push(videoCompleteObject);
      console.log("Pushed video complete object YT: ", videoCompleteObject);
    }
  }
};

// helpers

const constructVideoStartObject = (videotitle, videoDuration) => {
  return {
    event: "video_start",
    video_title: videotitle,
    video_duration: videoDuration,
  };
};

const constructVideoProgressObject = (
  videoTitle,
  videoCurrentTime,
  videoPercent,
  videoDuration
) => {
  return {
    event: "video_progress",
    video_title: videoTitle,
    video_current_time: videoCurrentTime,
    video_percent: videoPercent,
    video_duration: videoDuration,
  };
};

const constructVideoCompleteObject = (
  videoTitle,
  videoPercent,
  videoDuration
) => {
  return {
    event: "video_complete",
    video_title: videoTitle,
    video_percent: videoPercent,
    video_duration: videoDuration,
  };
};

const constructGA4CartObject = (item, event = "") => {
  return {
    event: event,
    value: item.line_price / 100.0,
    currency: Shopify.currency.active,
    item_name: item.product_title,
    item_id: `shopify_GB_${item.product_id}_${item.variant_id}`,
    price: item.price / 100.0,
    item_category: item.product_type,
    quantity: item.quantity,
  };
};

const setGa4CartObjectToSessionStorage = (variantId) => {
  getGa4Object(variantId).then((ga4Object) => {
    const variantId = ga4Object._variantId;
    delete ga4Object._variantId;
    sessionStorage.setItem(variantId, JSON.stringify(ga4Object));
  });
};

// Function used to construct object for quick_add_to_cart event and update sessionStorage for remove_from_cart event
const getGa4Object = (variantId) => {
  return new Promise((resolve, reject) => {
    let intervalCounter = 0;
    let ga4Object = null;
    const getCartItems = () => {
      if (intervalCounter > 10) {
        reject(null);
      }

      monster_getCartItems().then((data) => {
        const foundedItem = data.items.find(
          (item) => item.variant_id === variantId
        );
        const ga4ObjectFromSessionStorage = JSON.parse(
          sessionStorage.getItem(variantId)
        );

        if (ga4ObjectFromSessionStorage?.value === foundedItem?.line_price) {
          intervalCounter++;
          setTimeout(getCartItems, 500);
        } else {
          if (foundedItem) {
            ga4Object = constructGA4CartObject(foundedItem);
            ga4Object._variantId = foundedItem.variant_id;
            resolve(ga4Object);
          } else {
            intervalCounter++;
            setTimeout(getCartItems, 500);
          }
        }
      });
    };
    getCartItems();
  });
};

const _getCustomerId = () => {
  try {
    let curr = window.ShopifyAnalytics.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  try {
    let curr = window.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  return null;
};
